import StorageService from '@/services/storage-service'
import ShopService from '@/services/shop-service'
import CategoryAPIs from '@/api/store/category'

export default {
  namespaced: true,
  state: {
    currentStoreId: StorageService.getItem('bya3com_store_account', null),
    stores: [],
    categories: [],
    categoriesFetched: false,
    items: [],
    itemsFetched: false,
    fetchedSettings: {},
  },
  getters: {
    stores: (state: any) => state.stores ?? [],
    currentStoreId: (state: any) => state.currentStoreId,
    flatCategories: (state: any) => ShopService.flatCategories(state.categories) ?? [],
    flatItems: (state: any) => ShopService.flatItems(state.items) ?? [],
    currentStore: (state: any) => state.stores.find((store: any) => store.id === state.currentStoreId) ?? {},
  },
  mutations: {
    SET_STORES(state: any, stores: Array<any>) {
      state.stores = stores
      if (!state.currentStoreId || !stores.find(b => b.id === state.currentStoreId)) {
        state.currentStoreId = stores[0]?.id
      }
    },
    SET_STORE(state: any, accountId: number) {
      state.currentStoreId = accountId
    },
    SET_CATEGORIES(state: any, categories: any) {
      state.categories = categories
      state.categoriesFetched = true
    },
    SET_ITEMS(state: any, items: any) {
      state.items = items
      state.itemsFetched = true
    },
    SET_FETCHING_SETTINGS(state: any, accountId: number) {
      state.fetchedSettings[accountId] = true
    },
    RESET(state: any) {
      state.fetchedSettings = {}
    },
  },
  actions: {
    SET_STORE(context: any, accountId: number) {
      context.commit('SET_STORE', accountId)

      if (!context.rootGetters['auth/impersonate']) {
        StorageService.setItem('bya3com_store_account', accountId)
      }
    },
    async FETCH_CATEGORIES(context: any, storeId: number) {
      if (context.state.categoriesFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      return await CategoryAPIs.search(storeId)
    },
  },
}
